module.exports = __webpack_public_path__ + "img/orange_117.9af378ca.png";